import { useEffect } from 'react';

// Bump this string any time you want all users to hard-reload
const CURRENT_VERSION = '1.1.2';
const STORAGE_KEY = 'app_version';

const useVersionCheck = () => {
  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored !== CURRENT_VERSION) {
      // Store the new version first so we don't loop
      localStorage.setItem(STORAGE_KEY, CURRENT_VERSION);
      // Hard reload — bypasses browser cache
      window.location.reload();
    }
  }, []);
};

export default useVersionCheck;
